/** "3 selected · Add to dataset · Send to annotation · Clear". */

import { Button } from "@/components/ui/button";
import { plural } from "@/lib/format";
import { ProjectAction } from "@/features/projects/project-action";

export function SelectionBar({
  count,
  onAddToDataset,
  onSendToAnnotation,
  onClear,
}: {
  count: number;
  onAddToDataset: () => void;
  onSendToAnnotation: () => void;
  onClear: () => void;
}) {
  if (count === 0) return null;
  return (
    <div className="flex items-center gap-2 rounded-[9px] bg-subtle px-3 py-2 text-xs" aria-label="Selection">
      <span className="font-medium">{plural(count, "item")} selected</span>
      <ProjectAction permission="datasets:write">
        <Button size="sm" onClick={onAddToDataset}>
          Add to dataset
        </Button>
      </ProjectAction>
      <ProjectAction permission="annotations:write">
        <Button size="sm" onClick={onSendToAnnotation}>
          Send to annotation
        </Button>
      </ProjectAction>
      <Button size="sm" variant="ghost" onClick={onClear}>
        Clear
      </Button>
    </div>
  );
}
